
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { Address } from 'src/app/models/address.model';
import { NotificationData } from 'src/app/models/notificationData.model';
import { Offer } from 'src/app/models/offer.model';
import { Profile } from 'src/app/models/profile.model';
import { ApiService } from '../api/api.service';
import { AuthService } from '../auth/auth.service';
import { ObjSetterService } from '../objSetter/obj-setter.service';

@Injectable({
  providedIn: 'root'
})
export class ProfileService {
  private _profile = new BehaviorSubject<Profile>(null);
  private _uOffers = new BehaviorSubject<Offer[]>([]);
  private _uInactiveOffers = new BehaviorSubject<Offer[]>([]);
  private _notifications = new BehaviorSubject<NotificationData[]>([]);


  get profile() {
    return this._profile.asObservable();
  }

  get offers() {
    return this._uOffers.asObservable();
  }

  get inactiveOffers() {
    return this._uInactiveOffers.asObservable();
  }

  get notifications() {
    return this._notifications.asObservable();
  }

  constructor(
    private authService: AuthService,
    private apiService: ApiService,
    private objSetterService: ObjSetterService
  ) { }


  async getProfileInfo() {
    const user = this._profile.value;
    if (user) {
      return user;
    } else {
      return (await this.setProfile_db());
    }
  }

  setProfileInfo(profile: any) {
    const data = this.objSetterService.getProfileObj(profile);
    this._profile.next(data);
  }

  async setProfile_db() {
    try {
      const uid = await this.authService.getId();
      let _profile: any = await (await (this.apiService.collection('users').doc(uid).get().toPromise())).data();
      _profile.id = uid;

      let profile: Profile = this.objSetterService.getProfileObj(_profile);
      profile.notification_token = _profile?.notification_token
      this.setProfileInfo(profile);
      return profile;
    } catch (e) {
      throw (e);
    }
  }

  async getUserProfileDB() {
    try {
      const uid = await this.authService.getId();
      const profile: any = await (await (this.apiService.collection('users').doc(uid).get().toPromise())).data();
      return this.objSetterService.getProfileObj(profile);
    } catch (e) {
      throw (e);
    }
  }

  async getPaymentId() {
    try {
      const uid = await this.authService.getId();
      const profile: any = await (await (this.apiService.collection('users').doc(uid).get().toPromise())).data();
      return profile?.payment_customer_id;
    } catch (e) {
      throw (e);
    }
  }

  async getUserTypeDB() {
    try {
      const uid = await this.authService.getId();
      const profile: any = await (await (this.apiService.collection('users').doc(uid).get().toPromise())).data();
      return this.objSetterService.getProfileObj(profile).type;
    } catch (e) {
      throw (e);
    }
  }

  async setActiveOffers(lastDoc = []) {
    try {
      const uid = await this.authService.getId();
      let res: any = await this.apiService.getCollectionBy1Param('offers', { field: 'uid', value: uid }, { field: 'date', value: 'desc' }, lastDoc);
      if (!res || !res?.data || res?.data.length == 0) return;

      const returndData: Offer[] = this.objSetterService.getOffersListObj(res?.data); //this.setOfferObj(res?.data, uid);

      let offersValue = this._uOffers.getValue();
      this._uOffers.next(offersValue ? offersValue.concat(returndData) : returndData);
      console.log('_uOffers', this._uOffers.getValue());

      return res?.lastDoc;
    } catch (e) {
      throw (e)
    }
  }

  async setAdminActiveOffers(createrForId, lastDoc = []){
    try {
      const uid = await this.authService.getId();
      let res: any = await this.apiService.getCollectionBy2Param('offers', { field: 'uid', value: uid }, { field: 'createrForId', value: createrForId }, { field: 'date', value: 'desc' }, 40, lastDoc);
      if (!res || !res?.data || res?.data.length == 0) return;

      const returndData: Offer[] = this.objSetterService.getOffersListObj(res?.data); //this.setOfferObj(res?.data, uid);

      let offersValue = this._uOffers.getValue();
      this._uOffers.next(offersValue ? offersValue.concat(returndData) : returndData);
      console.log('_uOffers', this._uOffers.getValue());

      return res?.lastDoc;
    } catch (e) {
      throw (e)
    }
  }

  async setInactiveOffers(lastDoc = []) {
    try {
      const uid = await this.authService.getId();
      let res: any = await this.apiService.getCollectionBy1Param('inactive-offers', { field: 'uid', value: uid }, { field: 'date', value: 'desc' }, lastDoc);
      if (!res || !res?.data || res?.data.length == 0) return;

      const returndData: Offer[] = this.objSetterService.getOffersListObj(res?.data); //this.setOfferObj(res?.data, uid);

      let offersValue = this._uInactiveOffers.getValue();
      this._uInactiveOffers.next(offersValue ? offersValue.concat(returndData) : returndData);
      console.log('_uInactiveOffers', this._uInactiveOffers.getValue());

      return res?.lastDoc;
    } catch (e) {
      throw (e)
    }
  }

  async setAdminInactiveOffers(createrForId, lastDoc = []){
    try {
      const uid = await this.authService.getId();
      let res: any = await this.apiService.getCollectionBy2Param('inactive-offers', { field: 'uid', value: uid }, { field: 'createrForId', value: createrForId }, { field: 'date', value: 'desc' }, 40, lastDoc);
      if (!res || !res?.data || res?.data.length == 0) return;

      const returndData: Offer[] = this.objSetterService.getOffersListObj(res?.data); //this.setOfferObj(res?.data, uid);

      let offersValue = this._uInactiveOffers.getValue();
      this._uInactiveOffers.next(offersValue ? offersValue.concat(returndData) : returndData);
      console.log('_uInactiveOffers', this._uInactiveOffers.getValue());

      return res?.lastDoc;
    } catch (e) {
      throw (e)
    }
  }


  async setNotificationList(lastDoc = null) {
    try {

      let res: any = await this.apiService.getCollection('messages', { field: 'date', value: 'asc' }, lastDoc);
      if (!res || !res?.data || res?.data.length == 0) return

      const returndData: NotificationData[] = this.objSetterService.getNotificationListObj(res?.data);

      let notificationsValue = this._notifications.getValue();
      this._notifications.next(notificationsValue ? notificationsValue.concat(returndData) : returndData);
      console.log('_notifications', this._notifications.getValue());

      return res?.lastDoc;
    } catch (e) {
      throw (e)
    }
  }

  async getReports(lastDoc = null) {
    try {
      const uid = await this.authService.getId();
      let res: any = await this.apiService.getCollectionBy1Param('reports', { field: 'reporterId', value: uid }, { field: 'date', value: 'asc' }, lastDoc)
      //await this.apiService.getCollectionBy2Param('reports', {p1: 'rid', p2: 'states'}, {p1: uid, p2: true}, lastDoc)
      if (!res || !res?.data || res?.data.length == 0) return null;
      return res;
    } catch (e) {
      throw (e)
    }
  }

  async getPayments(lastDoc = null) {
    try {
      const uid = await this.authService.getId();
      let res: any = await this.apiService.getCollectionBy1Param('payments', { field: 'uid', value: uid }, { field: 'products.creation_date', value: 'asc' }, lastDoc)
      if (!res || !res?.data || res?.data.length == 0)
        return null;
      console.log(res);

      return res;
    } catch (e) {
      throw (e)
    }
  }

  async updateProfile(data) {
    try {
      const uid = await this.authService.getId();
      const profile = this._profile.value;

      const dataUid = data.uid
      delete data?.uid;
      if (profile?.type?.value != 'office') delete data?.coordinates;

      await this.apiService.collection('users').doc(dataUid).update(data);

      if (dataUid == uid) {
        this._profile.next({
          ...profile,
          name: data.name,
          short_name: data.name.toLowerCase(),
          bio: data?.bio,
          email: data?.email ? data?.email : null,
          phone: data?.phone ? data?.phone : null,
          phone2: data?.phone2 ? data?.phone2 : null,
          coordinates: data?.coordinates ? data?.coordinates : null,
          country: data?.country ? data?.country : null,
        });
      }

    } catch (e) {
      console.log(e);
      throw (e);
    }
  }

  async updateAcountPakege(updatedtype) {
    try {
      const uid = await this.authService.getId();
      const profile = this._profile.value;

      // DB update
      await this.apiService.collection('users').doc(uid).update(updatedtype);

      // Local update
      // 1- rename keys to remove 'value.'
      // 2- update data locally
      const newTypeObj = {...updatedtype}
      for (var key in newTypeObj) {
        if (newTypeObj.hasOwnProperty(key)) {
          newTypeObj[key.replace('type.','')] = newTypeObj[key];
          delete newTypeObj[key];
        }
      }

      this._profile.next({
        ...profile,
        type: newTypeObj
      });
    } catch (e) {
      console.log(e);
      throw (e);
    }
  }

  async updateOffer(id: string, param) {
    try {
      const timestamp = this.apiService.getTimestamp();
      await this.apiService.collection('offers').doc(id).update({ ...param, date: timestamp() });


      const offers = this._uOffers.getValue().map(o => {
        if (o.id === id) {
          for (const [key, value] of Object.entries(param)) {
            o[key] = value;
          }
        }
        return o;
      });
      this._uOffers.next(offers);

    } catch (e) {
      console.log(e);
      throw (e);
    }
  }

  async updateProfileActiveNumOffers(num: number, _uid?) {
    try {

      // _uid for created user, is add, delete, inactivate or activate offer of created user


      const uid = _uid ? _uid : await this.authService.getId();
      await this.apiService.increment_decrement(num, 'users', uid, 'num_offers')

      if(!_uid){
        const pro = this._profile.value;
        this._profile.next({
          ...pro, num_offers: pro.num_offers + num
        });
      }
    } catch (e) {
      throw (e);
    }
  }

  async updateProfileAvilableNumOffers(num: number) {
    try {
      const uid = await this.authService.getId();
      const pro = this._profile.value;

      await this.apiService.increment_decrement(num, 'users', uid, 'type.avilable_offers');


      this._profile.next({
        ...pro, type: {
          ...pro.type,
          value: pro.type.value,
          avilable_offers: pro.type.avilable_offers + num
        }
      });
    } catch (e) {
      throw (e);
    }
  }

  async updateProfileSpecialNumOffers(newSpecialArray: any[]) {
    try {
      const uid = await this.authService.getId();
      const profile = this._profile.value;

      await this.apiService.collection('users').doc(uid).update({
        'type.avilable_special': newSpecialArray
      });

      this._profile.next({
        ...profile,
        type: {
          ...profile.type,
          avilable_special: newSpecialArray
        }
      });

    } catch (e) {
      throw (e);
    }
  }

  async updateProfilePhoto(img_url: any) {
    try {
      const uid = await this.authService.getId();
      await this.apiService.collection('users').doc(uid).update({ img_url: img_url });
      this._profile.next({ ...this._profile.value, img_url: img_url });

    } catch (e) {
      console.log(e);
      throw (e);
    }
  }

  addActiveOfferLocally(offer: Offer) {
    let offers = this._uOffers.getValue();
    offer.date = new Date() + '';

    if (offers.length > 0) offers.unshift(offer);
    else offers.push(offer);

    this._uOffers.next(offers);
  }

  addInactiveOfferLocally(offer: Offer) {
    let offers = this._uInactiveOffers.getValue();
    offer.date = new Date() + '';

    if (offers.length > 0) offers.unshift(offer);
    else offers.push(offer);

    this._uInactiveOffers.next(offers);
  }

  deleteOfferLocally(id: string, iaActive: boolean) {
    if(iaActive) this._uOffers.next((this._uOffers.value).filter(o => o.id !== id));
    else this._uInactiveOffers.next((this._uInactiveOffers.value).filter(o => o.id !== id));
  }

  deleteInactiveOfferLocally(id: string) {
    const offers = this._uInactiveOffers.value;
    this._uInactiveOffers.next(offers.filter(o => o.id !== id));
  }

  clearProfile() {
    this._profile.next(null);
  }

  clearOffers() {
    this._uOffers.next([]);
  }

  clearInactiveOffers() {
    this._uInactiveOffers.next([]);
  }



  clearNotifications() {
    this._notifications.next([]);
  }



  async addOffer(uploadOffer: Offer, address: Address) {
    try {

      // Take action
      // 1- add offer to DB
      // 2- update address
      // 3- update num_offers -> number of active offers
      // 4- add offer locally


      const response = await this.apiService.geoCollection('offers').add(uploadOffer);
      await this.apiService.updateAddress(1, address);
      await this.updateProfileActiveNumOffers(1, uploadOffer.createrForId);
      this.addActiveOfferLocally(uploadOffer)
      return response;

    } catch (e) {
      console.log(e);
      throw (e);
    }
  }


  async deleteOffer(offer: Offer) {
    try {

      // Take Action
      // 1- delete offer from DB
      // 2- update address
      // 3- update num_offers -> number of active offers
      // 4- delete offer locally

      await this.apiService.deleteOffer(offer.id, offer.imgsUrl, offer.status.value ? 'offers' : 'inactive-offers');
      await this.apiService.updateAddress(-1, offer.address);
      await this.updateProfileActiveNumOffers(-1, offer.createrForId);
      this.deleteOfferLocally(offer.id, offer.status.value);

    } catch (e) {
      console.log(e);
      throw (e);
    }
  }

  async inactivateOffer(_offer: Offer) {
    try {

      // update status and move it to offer + add to acount offers
      let res: any = (await (this.apiService.collection('offers').doc(_offer.id).get().toPromise()));
      const offer = res.data();
      const inactivateOffer: any = {
        ...offer,
        status: {
          value: false,
          expired_date: offer.status.expired_date
        },
        isSpecial: {
          value: false,
          expired_date: null,
          order_id: null
        }
      }

      // 1- write offer on inactive-offers collection
      // 2- delete offer from offers
      await this.apiService.inactivateOffer(res.id, inactivateOffer);

      // 3- update avilable Offers
      // 4- update address
      // 5- update num_offers -> number of active offers
      // 6- delete offer from active locally
      // 7- add offer to inactive locally

      await this.apiService.updateAddress(-1, offer.address);
      await this.updateProfileActiveNumOffers(-1, _offer.createrForId);
      this.deleteOfferLocally(_offer.id, _offer.status.value);
      this.addInactiveOfferLocally(this.objSetterService.getOffersObj({...inactivateOffer, id:res.id}));


    } catch (e) {
      console.log(e);
      throw (e);
    }
  }


  async activateOffer(_offer: Offer, newTime) {
    try {

      // update status and move it to offer + add to acount offers
      let res: any = (await (this.apiService.collection('inactive-offers').doc(_offer.id).get().toPromise()));
      const offer = res.data();
      const activateOffer: any = {
        ...offer,
        status: {
          value: true,
          expired_date: newTime
        }
      }

      // 1- write offer on offers collection
      // 2- delete offer from inactive-offers collection
      await this.apiService.activateOffer(res.id, activateOffer);

      // 3- update address
      // 4- update num_offers -> number of active offers
      // 5- delete offer from inactive locally
      // 6- add offer to active locally

      await this.apiService.updateAddress(+1, offer.address);
      await this.updateProfileActiveNumOffers(+1, _offer.createrForId);
      this.deleteOfferLocally(_offer.id, _offer.status.value);
      this.addActiveOfferLocally(this.objSetterService.getOffersObj({...activateOffer, id:res.id}));

    } catch (e) {
      console.log(e);
      throw (e);
    }
  }


  async setPakegeToAccount(pakege: string, order_id: string, avilible_offers: number, avilable_special: any[], expired_date: Date){
    try{

      // Update user type information on DB and locally
      await this.updateAcountPakege({
        'type.value': 'office',
        'type.avilable_offers': avilible_offers,
        'type.pakege': pakege,
        'type.avilable_special': (avilable_special && avilable_special?.length > 0) ? avilable_special : null,
        'type.expired_date': expired_date,
        'type.order_id': order_id
      });

    } catch(e){
      throw(e);
    }
  }


  async unsetPakegeToAccount(avilible_offers: number){
    try{

      // Update user type information on DB and locally
      await this.updateAcountPakege({
        'type.value': 'user',
        'type.avilable_offers': (avilible_offers < 0) ? 0 : avilible_offers,
        'type.pakege': null,
        'type.avilable_special': [],
        'type.expired_date': null,
        'type.order_id': null
      });
    } catch(e){
      throw(e);
    }
  }


  async deleteMyAccount(){
    try{
      // Delete Active Offers Take Actions
      // 1- get all offers of user
      // 2- deleting offers synchronously from offers collection
      // 3- delete created account from user collection
      // 4- update address

      // Delete Inactive Offers Take Actions
      // 1- get all inactive offers of user
      // 2- deleting offers synchronously from offers collection
      // 3- delete created account from user collection


      // Delete created account locally
      // 1- Delete profile image
      // 2- Delete account
      // -------------------------------------------------------------



      const profile = await this.getProfileInfo()
      let snapActive = await this.apiService.collection('offers').ref
      .where('uid', '==', profile.uid)
      .orderBy('date', 'desc')
      .get();

    if (snapActive.docs.length != 0) {
      snapActive.docs.forEach(async (element) => {
        let offer: any = element.data();
        offer.id = element.id;
        await this.apiService.deleteOffer(offer.id, offer.imgsUrl, 'offers');
        await this.apiService.updateAddress(-1, offer.address);
      });
    }

      // Delete Inactive Offers Take Actions
      // 1- get all inactive offers of user
      // 2- deleting offers synchronously from offers collection
      // 3- delete created account from user collection
      // 4- delete created account locally
      // -------------------------------------------------------------

      let snapInActive = await this.apiService.collection('inactive-offers').ref
        .where('uid', '==', profile.uid)
        .orderBy('date', 'desc')
        .get();

      if (snapInActive.docs.length != 0) {
        snapInActive.docs.forEach(async (element) => {
          let offer: any = element.data();
          offer.id = element.id;
          await this.apiService.deleteOffer(offer.id, offer.imgsUrl, 'inactive-offers');
        });
      }

      if(profile?.img_url) await this.apiService.deleteImg(profile?.img_url);
      await this.apiService.deleteAccountInfo(profile.uid);
      await this.authService.deleteAccountAuth();

      this.clearProfile();
      this.clearOffers();

    }catch(e){
      console.log(e);
      throw(e);
    }
  }

}
